import { Box, Stack, Typography } from "@mui/material"

const ColorInfoBox = ({ color, text, width=24, height=14, isCircle=false, variant='h6', spacing=1.5 }) => {
    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'start'} spacing={spacing}>
            <Box sx={{ width: width, height: height, backgroundColor: color, borderRadius: isCircle && (width / 2) }} />
            <Typography variant={variant}>{text}</Typography>
        </Stack>
    )
}

export default ColorInfoBox